import * as React from "react";
import LoadingIndicator from "../../components/LoadingIndicator";
import { useLogoutHandler } from "../../utils/useLogoutHandler";

const Logout = () => {
  const { logout } = useLogoutHandler();
  const hasStartedLogout = React.useRef(false);

  React.useEffect(() => {
    if (hasStartedLogout.current) {
      return undefined;
    }

    hasStartedLogout.current = true;

    const executeLogout = async () => {
      await logout();
    };

    executeLogout();

    return undefined;
  }, [logout]);

  return <LoadingIndicator />;
};

export default Logout;
